import { JsonObject } from 'ta-json';
import {
  GetAllRetailers_allRetailers_edges_node_retailerOptions_configuratorOptions,
} from '@src/app/generated/GetAllRetailers';
import { PortalAsset } from '@src/app/model/portal-asset';
import { ConfiguratorOptionsInput } from '@src/app/generated/globalTypes';
import { ConfiguratorOptions } from '@ess/jg-rule-executor/dist/src/domain/configurator-options';
import { PortalFont } from '@src/app/model/portal-font';
import { PortalConfigurationIcons } from '@src/app/model/portal-configuration-icons';
import { PortalPriceAppearance } from '@src/app/model/portal-price-appearance';
import { PortalDiscountedPriceAppearance } from '@src/app/model/discounted-price-appearance';
import { PortalEnvironmentSettings3JS } from '@src/app/model/portal-environment-settings-3js';

/**
 * ConfiguratorOptions
 */
@JsonObject()
export class PortalConfiguratorOptions extends ConfiguratorOptions {
  static fromGql(
    gql: GetAllRetailers_allRetailers_edges_node_retailerOptions_configuratorOptions
  ): PortalConfiguratorOptions {
    return new PortalConfiguratorOptions(
      gql.favicon ? PortalAsset.fromGql(gql.favicon) : undefined,
      gql.banner ? PortalAsset.fromGql(gql.banner) : undefined,
      gql.font ? PortalFont.fromGql(gql.font) : undefined,
      gql.configuratorIcons ? PortalConfigurationIcons.fromGql(gql.configuratorIcons) : undefined,
      gql.priceAppearance ? PortalPriceAppearance.fromGql(gql.priceAppearance) : new PortalPriceAppearance(null, null),
      gql.bottomLogo,
      gql.saveButton,
      gql.hideSteps,
      gql.hideMenuSaveButton,
      gql.hideMenuOpenButton,
      gql.hideShareContent,
      gql.extraCardWidth,
      gql.discountedPriceAppearance
        ? PortalDiscountedPriceAppearance.fromGql(gql.discountedPriceAppearance)
        : new PortalDiscountedPriceAppearance(null, null, null),
      gql.hoverOverEffectEnabled,
      gql.environmentSettingsEditView
        ? PortalEnvironmentSettings3JS.fromGql(gql.environmentSettingsEditView)
        : null,
      gql.environmentSettingsResultView
        ? PortalEnvironmentSettings3JS.fromGql(gql.environmentSettingsResultView)
        : null,
      gql.saveWithMail
    );
  }

  toGqlInput(): ConfiguratorOptionsInput {
    return {
      favicon: (this.favicon as PortalAsset)?.toGqlInput(),
      banner: (this.banner as PortalAsset)?.toGqlInput(),
      font: (this.font as PortalFont)?.toGqlInput(),
      configuratorIcons: (this.configuratorIcons as PortalConfigurationIcons)?.toGqlInput(),
      priceAppearance: (this.priceAppearance as PortalPriceAppearance)?.toGqlInput(),
      bottomLogo: this.bottomLogo,
      saveButton: this.saveButton,
      hideSteps: this.hideSteps,
      hideMenuSaveButton: this.hideMenuSaveButton,
      hideMenuOpenButton: this.hideMenuOpenButton,
      hideShareContent: this.hideShareContent,
      extraCardWidth: this.extraCardWidth,
      discountedPriceAppearance: (this.discountedPriceAppearance as PortalDiscountedPriceAppearance)?.toGqlInput(),
      hoverOverEffectEnabled: this.hoverOverEffectEnabled,
      environmentSettingsEditView: PortalEnvironmentSettings3JS.toGqlInput(this.environmentSettingsEditView),
      environmentSettingsResultView: PortalEnvironmentSettings3JS.toGqlInput(this.environmentSettingsResultView),
      saveWithMail: this.saveWithMail,
    };
  }
}
